module.exports = __webpack_public_path__ + "img/High_School.87439b82.svg";